import Loader from 'vue-spinner/src/PulseLoader';
import SHA256 from 'sha256';

export default {
    name: 'passwordmodal',
    components: { Loader },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            ok: true,
            errorMessage: '',
            showLoader: false,
            isShowOldPassword: false,
            isShowNewPassword: false,
            isShowConfirmPassword: false,
            oldPasswordButton: 'Show',
            newPasswordButton: 'Show',
            confirmPasswordButton: 'Show',
            minLengthPassword: 8,
            showErrorMessage: false
        };
    },
    mounted() {
        this.$refs.oldPassword.focus();
    },
    props: {
        close: {
            type: Function,
        },
        submitChange: {
            type: Function,
        }
    },
    computed: {
        language() {
            return localStorage.getItem('lang')
        }
    },
    methods: {
        closeModal() {
            this.$props.close();
        },
        inputOldPassword(value) {
            if (this.oldPassword === '') {
                this.showErrorMessage = true;
                this.ok = true;
                this.errorMessage = 'Old Password cannot be empty';
            } else {
                this.showErrorMessage = false;
                this.ok = false;
                if (this.newPassword !== '') {
                    this.inputNewPassword(this.newPassword);
                }
                if (this.confirmPassword === '') {
                    this.ok = true;
                }
            }
        },
        inputNewPassword(value) {
            const regex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}).*$/g;
            if (this.newPassword === '') {
                this.showErrorMessage = true;
                this.ok = true;
                this.errorMessage = 'New Password cannot be empty';
            } else {
                this.showErrorMessage = false;
                this.ok = false;
                if (regex.test(value)) {
                    this.showErrorMessage = false;
                    this.ok = false;
                    this.errorMessage = '';
                    if (this.newPassword === this.oldPassword) {
                        this.showErrorMessage = true;
                        this.ok = true;
                        this.errorMessage = 'New Password must not be the same as the old Password';
                    } else if (this.confirmPassword !== '' && this.newPassword !== this.confirmPassword) {
                        this.showErrorMessage = true;
                        this.ok = true;
                        this.errorMessage = 'New Password does not match the Confirmation Password';
                    } else if (this.confirmPassword === '') {
                        this.ok = true;
                    } else if (this.oldPassword === '') {
                        this.showErrorMessage = true;
                        this.ok = true;
                        this.errorMessage = 'Old Password cannot be empty';
                    }
                } else {
                    this.showErrorMessage = true;
                    this.ok = true;
                    this.errorMessage = 'New Password must consist of at least 8 characters, uppercase letters, lowercase letters, and numbers';
                }
            }
        },
        inputConfirmPassword(value) {
            if (this.confirmPassword === '') {
                this.showErrorMessage = true;
                this.ok = true;
                this.errorMessage = 'Confirmation Password cannot be empty';
            } else if (this.newPassword === '') {
                this.showErrorMessage = true;
                this.ok = true;
                this.errorMessage = 'New Password cannot be empty';
            } else {
                this.showErrorMessage = false;
                this.ok = false;
                this.inputNewPassword(this.newPassword);
            }
        },
        approve() {
            this.showLoader = true;
            const credential = {
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                confirmPassword: this.confirmPassword
            }
            this.$store.dispatch('changeAdminPassword', {
                oldPassword: credential.oldPassword,
                newPassword: credential.newPassword,
                confirmPassword: credential.confirmPassword
            }).then((res) => {
                if (res.message == 'Success') {
                    this.$notify({
                        title: 'Success',
                        message: res.message,
                        icon: "ti-check",
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'success',
                    });

                    this.closeModal();
                } else if (res.message === 'The access token is invalid or has expired') {
                    this.$notify({
                        title: 'Failed',
                        message: res.message,
                        icon: "ti-na",
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger',
                    });
                    this.showLoader = false;
                    setTimeout(() => {
                        localStorage.clear();
                        location.reload();
                        window.location.href = '/';
                    }, 2000)
                } else {
                    this.$notify({
                        title: 'Failed',
                        message: res.message,
                        icon: "ti-na",
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger',
                    });
                    this.showLoader = false;
                }
            });
        },
        onClickOldPasswordButton() {
            this.isShowOldPassword = this.oldPasswordButton === 'Show' ? true : false;
            this.oldPasswordButton = this.oldPasswordButton === 'Show' ? 'Hide' : 'Show';

        },
        onClickNewPasswordButton() {
            this.isShowNewPassword = this.newPasswordButton === 'Show' ? true : false;
            this.newPasswordButton = this.newPasswordButton === 'Show' ? 'Hide' : 'Show';

        },
        onClickConfirmPasswordButton() {
            this.isShowConfirmPassword = this.confirmPasswordButton === 'Show' ? true : false;
            this.confirmPasswordButton = this.confirmPasswordButton === 'Show' ? 'Hide' : 'Show';

        },
        oldPasswordClass() {
            if (this.isShowOldPassword) {
                return 'show-pass'
            } else {
                return 'hide-pass'
            }
        },
        newPasswordClass() {
            if (this.isShowNewPassword) {
                return 'show-pass'
            } else {
                return 'hide-pass'
            }
        },
        confirmPasswordClass() {
            if (this.isShowConfirmPassword) {
                return 'show-pass'
            } else {
                return 'hide-pass'
            }
        },
    },
};
